/*!
 * darkStage.js — the page dark: inverted, so a light stage turns black
 * © 2026 Rob Canning — GPLv3
 *
 * Oscilla's dark mode is an invert of the whole page (a light score turns
 * dark), with what must keep its colours turned back by CSS: the live
 * console's layers (livecode.css), and on Oscilla Live's page its own
 * chrome, pictures and film (live.css). The score's switch keeps its
 * setting (transportUI.js); Oscilla Live's keeps its own (live.js).
 */

const INVERT = "invert(1) hue-rotate(180deg)";

export function setDarkStage(on) {
  document.documentElement.style.filter = on ? INVERT : "";
  document.body.style.background = on ? "black" : "";
}

export const isDarkStage = () => document.documentElement.style.filter.includes("invert");
